import { Dashboard } from './dashboard';
import { CustomSideMenu1 } from './dashboard';
import qpDashboard from 'sidemenu/menu-items(qp-admin)/dashboard';
// ==============================|| MENU ITEMS ||============================== //
const isSdCustomAdmin = localStorage.getItem('isSdCustomAdmin') === 'true';
const isQpAdmin = window.location.pathname.startsWith('/qp-admin');

let selectedMenu;

if (isSdCustomAdmin) {
    selectedMenu = CustomSideMenu1;
} else if (isQpAdmin) {
    selectedMenu = qpDashboard;
} else {
    selectedMenu = Dashboard;
}

const superDistributorMenuItems = {
    items: [selectedMenu]
};

export default superDistributorMenuItems;
